// extracted by mini-css-extract-plugin
export default {"textCellRoot":"text-cell-root__bwBuYCzT","numberCellRoot":"number-cell-root__M9qlRl3w","text":"text__Xr70st28","matchPart":"match-part__urKlMERH"};